/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: tXkSR39sgCDWSitZxC5xFV
// Component: uG5_fPM0sK

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  SingleBooleanChoiceArg,
  StrictProps,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: tXkSR39sgCDWSitZxC5xFV/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "../PP__plasmickit_design_system.module.css"; // plasmic-import: tXkSR39sgCDWSitZxC5xFV/projectcss
import sty from "./PlasmicListSectionSeparator.module.css"; // plasmic-import: uG5_fPM0sK/css

createPlasmicElementProxy;

export type PlasmicListSectionSeparator__VariantMembers = {
  center: "center";
};
export type PlasmicListSectionSeparator__VariantsArgs = {
  center?: SingleBooleanChoiceArg<"center">;
};
type VariantPropType = keyof PlasmicListSectionSeparator__VariantsArgs;
export const PlasmicListSectionSeparator__VariantProps =
  new Array<VariantPropType>("center");

export type PlasmicListSectionSeparator__ArgsType = {};
type ArgPropType = keyof PlasmicListSectionSeparator__ArgsType;
export const PlasmicListSectionSeparator__ArgProps = new Array<ArgPropType>();

export type PlasmicListSectionSeparator__OverridesType = {
  root?: Flex__<"div">;
  freeBox?: Flex__<"div">;
};

export interface DefaultListSectionSeparatorProps {
  center?: SingleBooleanChoiceArg<"center">;
  className?: string;
}

const $$ = {};

function PlasmicListSectionSeparator__RenderFunc(props: {
  variants: PlasmicListSectionSeparator__VariantsArgs;
  args: PlasmicListSectionSeparator__ArgsType;
  overrides: PlasmicListSectionSeparator__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "center",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.center,
      },
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        { [sty.rootcenter]: hasVariant($state, "center", "center") }
      )}
    >
      {(hasVariant($state, "center", "center") ? true : false) ? (
        <div
          data-plasmic-name={"freeBox"}
          data-plasmic-override={overrides.freeBox}
          className={classNames(projectcss.all, sty.freeBox, {
            [sty.freeBoxcenter]: hasVariant($state, "center", "center"),
          })}
        />
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "freeBox"],
  freeBox: ["freeBox"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  freeBox: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicListSectionSeparator__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicListSectionSeparator__VariantsArgs;
    args?: PlasmicListSectionSeparator__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicListSectionSeparator__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicListSectionSeparator__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicListSectionSeparator__ArgProps,
          internalVariantPropNames: PlasmicListSectionSeparator__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicListSectionSeparator__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicListSectionSeparator";
  } else {
    func.displayName = `PlasmicListSectionSeparator.${nodeName}`;
  }
  return func;
}

export const PlasmicListSectionSeparator = Object.assign(
  // Top-level PlasmicListSectionSeparator renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),

    // Metadata about props expected for PlasmicListSectionSeparator
    internalVariantProps: PlasmicListSectionSeparator__VariantProps,
    internalArgProps: PlasmicListSectionSeparator__ArgProps,
  }
);

export default PlasmicListSectionSeparator;
/* prettier-ignore-end */
